import firebase from './firebase';

export default {
    appVersion: process.APP_VERSION,
    firebase
}
